import { DateTimeService } from "../../services/date-time-service"

type CreateMonthDayTemplateArgs = {
  calendar: SchedulerStatic
  weekShortLabel: string
}

export const createMonthDayTemplate = ({ calendar, weekShortLabel }: CreateMonthDayTemplateArgs) => {
  return function monthDayTemplate(date: Date) {
    const day = date.getDate()

    // first visible cell of month grid
    const gridStart = (calendar as any)._min_date as Date
    const diffDays = Math.floor((date.getTime() - gridStart.getTime()) / 86400000)
    const isFirstColumn = diffDays % 7 === 0

    if (isFirstColumn) {
      const weekNumber = DateTimeService.getWeekNumber(date)
      return `
            <span class="dhx_month_week_number">${weekShortLabel} ${weekNumber}</span>
            <span class="dhx_month_day_number">${day}</span>
          `
    }

    return `<div class="dhx_month_day_number">${day}</div>`
  }
}
